export default "__VITE_ASSET__DeGQ93Ew__"